import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import { Providers } from './app/Providers';
import { router } from './app/router';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    {/* Runs BEFORE React paints, resolving the stored colour scheme from
        localStorage and stamping it on <html>. Without it the first frame always
        uses the default scheme and then repaints — every reload flashes light
        before settling to dark. */}
    <InitColorSchemeScript attribute="data-mui-color-scheme" />
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
